var map = {
	"./ourpeople-placeholder.png": "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/ourpeople-placeholder.png",
	"./profile-placeholder.png": "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/profile-placeholder.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tool/project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive /\\.png$/";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive \.png$
// module id = /tool/project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive /\.png$/
// module chunks = site__ale001